import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import { Component } from 'react';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';

class StudentPeriodicals extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //VARIABLE TO GET PERIODICAL DATA LIST
            periodicalDataLoading: false,
            periodicalData: {},
            totalPeriodicalItem: 0,
            periodicalSortedIdArray: [],

            linkedInstituteArray: {},
            linkedIidArray: [],
        }
    }

    componentDidMount() {
        this.GetAssignedInstituteList();
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                this.getPeriodicalList()
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    getPeriodicalList = async () => {
        this.setState({ periodicalDataLoading: true })

        let requestData = {
            "iid": config.institute_id,
            "iidArray": this.state.linkedIidArray,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filterData": {
                "filteredIID": config.institute_id
            }
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPeriodicalList',
            requestData,
            '/api/library/learner.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            periodicalData: apiResult.data,
                            totalPeriodicalItem: apiResult.totalRecords,
                            periodicalSortedIdArray: apiResult.sortedIdArray,
                            periodicalDataLoading: false
                        });
                    } else {
                        this.setState({
                            periodicalData: {},
                            totalPeriodicalItem: 0,
                            periodicalSortedIdArray: [],
                            periodicalDataLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        periodicalData: {},
                        periodicalDataLoading: false,
                        periodicalSortedIdArray: []
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }


    // componentDidUpdate(prevProps) {
    //     // Compare with previous props to avoid unnecessary calls
    //     if (
    //         (!prevProps.iidArray?.iidArray || prevProps.iidArray.iidArray.length === 0) &&
    //         this.props.iidArray?.iidArray &&
    //         this.props.iidArray.iidArray.length > 0
    //     ) {
    //         this.GetAllMyIssuedResourceList();
    //     }
    // }


    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber }, () => {
            this.getPeriodicalList();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value }, () => {
            this.getPeriodicalList();
        });
    }

    render() {

        return (
            <>
                <RoutingMenu activeScreen="userPeriodicals" />

                <div className="libraryComponents-container pr-3">
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4>Periodicals/Journals</h4>
                        </div>
                    </div>

                    {/* list table */}
                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <table className="table table-bordered  vm_libraryReport_table" id="donorListReport">
                                    <thead>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="11"></th>
                                            </tr>
                                            <th>Sr.No.</th>
                                            <th>Title</th>
                                            <th>No. of Copies</th>
                                            <th>Category</th>
                                            <th>Publisher</th>
                                            <th>Vendor</th>
                                            <th>Periodicity</th>
                                            <th>ISSN</th>
                                            <th>Volume</th>
                                            <th>Editor</th>
                                            <th>Department</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.periodicalDataLoading ?
                                                <tr>
                                                    <td colSpan="11">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                this.state.periodicalSortedIdArray?.length > 0 ? (
                                                    this.state.periodicalSortedIdArray.map((periodicalUID, index) => {
                                                        const issuedResourceItem = this.state.periodicalData[periodicalUID];
                                                        if (!issuedResourceItem) return null; // Skip if missing

                                                        // Truncate Department (max 20 chars)
                                                        const periodicalDepartment =
                                                            issuedResourceItem?.Department && issuedResourceItem.Department.length !== 0
                                                                ? issuedResourceItem.Department.toString()
                                                                : '';

                                                        let subStringDept = periodicalDepartment;
                                                        if (subStringDept.length > 20) {
                                                            subStringDept = subStringDept.substring(0, 20) + '...';
                                                        }

                                                        return (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                <td>{issuedResourceItem?.title.charAt(0).toUpperCase() + issuedResourceItem?.title.slice(1) || ""}</td>
                                                                <td>{issuedResourceItem?.totalNumberOfIssues || ""}</td>
                                                                <td>{issuedResourceItem?.periodicalCategoryName || ""}</td>
                                                                <td>{issuedResourceItem?.publisher || ""}</td>
                                                                <td>{issuedResourceItem?.Vendor}</td>
                                                                <td>{issuedResourceItem?.periodicity.charAt(0).toUpperCase() + issuedResourceItem?.periodicity.slice(1) || ""}</td>
                                                                <td>{issuedResourceItem?.ISSN || ''}</td>
                                                                <td>{issuedResourceItem?.volume || ''}</td>
                                                                <td>{issuedResourceItem?.editor || ''}</td>
                                                                <td title={periodicalDepartment}>
                                                                    {subStringDept}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })) :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.periodicalData).length > 0 || Object.keys(this.state.periodicalData).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalPeriodicalItem}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.updatePaginationCount}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalPeriodicalItem || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentPeriodicals);